<template>
  <el-autocomplete
    v-bind="$attrs"
    v-on="$listeners"
    :fetch-suggestions="querySearch"
  ></el-autocomplete>  
</template>
<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
      dataList: []
    }
  },
  props: {
    formName: {
      type: String,
      default: ""
    },
    propName: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapState(['autoInput'])
  },
  created(){
    this.loadStore()
  },
  mounted() {
    this.dataList = this.loadAll();
  },
  methods: {
    querySearch(queryString, cb) {
      var dataList = this.dataList;
      var results = queryString ? dataList.filter(this.createFilter(queryString)) : dataList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (data) => {
        return (data.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1);
      };
    },
    loadAll() {
      let map = this.autoInput.map && this.autoInput.map[this.formName] && this.autoInput.map[this.formName][this.propName]
      return map || []
    },
    loadStore(){
      this.$store.dispatch("loadData")
    },
  }
}
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/AutoInput.vue